module.exports = __webpack_public_path__ + "img/img3.f88c29d9.svg";